import React from "react";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";

import analytics from "fond/analytics";
import { useCanIPlanner } from "fond/hooks/useCanIPlanner";
import { ProjectsView, Store } from "fond/types";
import { NavLink } from "fond/widgets/Link/NavLink";

/**
 * Default project header that will return text based on
 * user's ability to create projects
 */
const ProjectListHeader: React.FC = () => {
  const filters = useSelector((state: Store) => state.projects.filters);
  const { canBuy, hasSub } = useCanIPlanner();

  const workspaceMessage = "This is your account workspace, where you can design, manage, and collaborate on network projects with others.";
  const headerDescription: Record<ProjectsView, string | JSX.Element> = {
    workspace: canBuy ? (
      <>
        {workspaceMessage}
        <br />
        <br />
        If you would like to access all these premium features,{" "}
        <NavLink onClick={() => analytics.track("workspace.upgrade.link.clicked")} to={hasSub ? "/subscription/manage" : "/subscription/get-started"}>
          upgrade
        </NavLink>{" "}
        to a planner subscription now.
      </>
    ) : (
      workspaceMessage
    ),
    shared: "Access projects and folders that others have granted permission for you to view and/or edit.",
    recent: "Projects you visited recently.",
    starred: "Quickly navigate to your most important and frequently accessed content.",
  };

  return <Typography width="70%">{headerDescription[filters]}</Typography>;
};

export default ProjectListHeader;
